import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{}> & React.HTMLAttributes<HTMLDivElement>;

export const Pill = ({ children, className }: Props) => (
  <div
    className={clsx(
      'inline-block rounded-lg bg-granny-apple py-[6px] px-[12px] text-xs overflow-hidden text-ellipsis',
      className,
    )}
  >
    {children}
  </div>
);
